import { useToast } from "@chakra-ui/react";
import { useCallback } from "react";

// Define the type for the toast return interface
interface SmartToastProps {
  success: (description: string) => void;
  error: (error: any, defaultMessage: string) => void;
}

export default function useSmartToast(): SmartToastProps {
  const toast = useToast();

  // Use useCallback to memoize functions and prevent recreation on each render
  const success = useCallback(
    (description: string) => {
      toast({
        title: "Success",
        description,
        status: "success",
        duration: 5000,
        isClosable: true
      });
    },
    [toast]
  );

  const error = useCallback(
    (err: any, defaultMessage: string) => {
      const desc =
        err?.response?.data?.message ||
        err?.message ||
        (typeof err === "string" ? err : null) ||
        defaultMessage ||
        "An error occurred.";
      toast({
        title: "Error",
        description: desc,
        status: "error",
        duration: 5000,
        isClosable: true
      });
    },
    [toast]
  );

  return {
    success,
    error
  };
}

interface SmartToastProps {
  success: (message: string) => void;
  error: (error, defaultMessage: string) => void;
}
